import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';
import { getType, isObjectEmptyValues } from '../../../../utils/index.js';

/**
 * 递归渲染对象/数组数据的子组件
 * @param {Object} props
 * @param {string} props.keyName - 字段名
 * @param {any} props.value - 字段值
 * @param {number} props.dep - 嵌套深度
 * @param {Object} props.config - 字段映射配置
 */
export const ChildMapRenderer = ({ keyName, value, dep, config = {} }) => {
  const type = getType(value);

  switch (type) {
    case 'null':
      return null;

    case 'string':
    case 'number':
      if (value || value === 0) {
        if (dep === 0) {
          return (
            <Form.Item label={config[keyName]?._Label || config[keyName] || keyName}>
              {value}
            </Form.Item>
          );
        }
        return (
          <p className="mb-10">
            <span><b>{config[keyName]?._Label || config[keyName] || keyName}: </b></span>
            <span>{value}</span>
          </p>
        );
      }
      return null;

    case 'bollean':
      if (dep === 0) {
        return (
          <Form.Item label={config[keyName]?._Label || config[keyName] || keyName}>
            {String(value)}
          </Form.Item>
        );
      }
      return (
        <p className="mb-10">
          <span><b>{config[keyName]?._Label || config[keyName] || keyName}: </b></span>
          <span>{String(value)}</span>
        </p>
      );

    case 'object':
      if (!isObjectEmptyValues(value)) {
        if (dep === 0) {
          return (
            <Form.Item label={config[keyName]?._Label || config[keyName] || keyName}>
              {Object.keys(value)?.map((ckey, index) => {
                if (!ckey || !value[ckey]) return <Fragment key={`empty-${index}`} />;
                const isSimpleType = ['string', 'number', 'boolean'].includes(getType(value[ckey]));
                if (isSimpleType) {
                  return (
                    <p key={`child-${index}`} className="mb-10">
                      <span><b>{config[keyName]?.[ckey]?._Label || config[keyName]?.[ckey] || ckey}: </b></span>
                      <span>{value[ckey]}</span>
                    </p>
                  );
                }
                return (
                  <Fragment key={`child-${index}`}>
                    <ChildMapRenderer
                      keyName={ckey}
                      value={value[ckey]}
                      dep={1}
                      config={config[keyName]}
                    />
                  </Fragment>
                );
              })}
            </Form.Item>
          );
        }
        return (
          <div className="mb-10">
            <span>
              {Object.keys(value)?.map((ckey, index) => {
                if (!ckey || !value[ckey]) return <Fragment key={`empty-${index}`} />;
                const isSimpleType = ['string', 'number', 'boolean'].includes(getType(value[ckey]));
                if (isSimpleType) {
                  return (
                    <p key={`child-${index}`} className="mb-10">
                      <span><b>{config[ckey]?._Label || config[ckey] || ckey}: </b></span>
                      <span>{value[ckey]}</span>
                    </p>
                  );
                }
                return (
                  <Fragment key={`child-${index}`}>
                    <ChildMapRenderer
                      keyName={ckey}
                      value={value[ckey]}
                      dep={1}
                      config={config[keyName]}
                    />
                  </Fragment>
                );
              })}
            </span>
          </div>
        );
      }
      return null;

    case 'array':
      if (value.length > 0) {
        return (
          <>
            {value.map((item, index) => {
              const isSimpleType = ['string', 'number', 'boolean'].includes(typeof item);
              const label = config[keyName]?._Label || config[keyName] || keyName;
              return (
                <Fragment key={`array-${index}`}>
                  <Form.Item label={`${label}:识别结果${index + 1}`}>
                    {isSimpleType ? item : (
                      <ChildMapRenderer
                        keyName={keyName}
                        value={item}
                        dep={1}
                        config={config[keyName]}
                      />
                    )}
                  </Form.Item>
                </Fragment>
              );
            })}
          </>
        );
      }
      return null;

    default:
      return null;
  }
};
